import {getMessaging, getToken} from "firebase/messaging";
import firebaseApp from "@/utils/firebase";


const messaging = getMessaging(firebaseApp);

// onMessage(messaging, (payload) => {
//     console.log('Message received. ', payload);
// });

// const fcmToken =  () => getToken(messaging, {vapidKey: process.env.VUE_APP_FCM_SERVER_TOKEN})
const fcmToken =  () => getToken(messaging, {vapidKey: process.env.VUE_APP_FCM_SERVER_TOKEN})

export default fcmToken


